import { Pipe, PipeTransform } from '@angular/core';
import moment from "moment";
@Pipe({
    name: 'unixToMomentDate',
    standalone: false
})
export class UnixToMomentDatePipe implements PipeTransform {
  // Takes a unix timecode(epoch time in ms) and converts it to date string. Configurable with moment objs.
  transform(epoch, formatString? : string): string {
    formatString ? null : formatString = "MM/DD/YY HH:mm"
    const retval = moment(epoch).format(formatString) 
    return retval
  }

}
